<script setup>
import { computed, onBeforeMount } from 'vue'
import { onBeforeRouteUpdate } from 'vue-router'
import { useUsersStore } from '@/stores/users'
import UTAUserNavi from '@/components/user/UTAUserNavi.vue'
import UTAError404 from '@/components/UTAError404.vue'

const props = defineProps({
    uuid: {
        type: String,
        required: true
    }
})

const usersStore = useUsersStore()

const userProcess = computed(() => usersStore.userProcess)
const user        = computed(() => usersStore.user)

onBeforeMount(() => {
    usersStore.readUser(props.uuid)
})

onBeforeRouteUpdate(async (to, from) => {
    // Обновить данные пользователя при прямом переходе с одного пользователя на другого
    if(to.params.uuid !== from.params.uuid)
        usersStore.readUser(to.params.uuid)
})
</script>

<template>
    <div v-if="userProcess" class="d-flex justify-content-center align-items-center h-100">
        <div class="loader">
            <div class="spinner-border text-secondary" role="status">
                <span class="visually-hidden">Loading...</span>
            </div>
        </div>
    </div>
    <div v-else class="page page--user">
        <div v-if="user.uuid" class="page__container page__container--2cols align-items-stretch">
            <div class="page__leftcol">
                <UTAUserNavi :uuid="props.uuid ? props.uuid : ''" />
            </div>
            <div class="page__rightcol">
                <router-view></router-view>
            </div>
        </div>
        <UTAError404 v-else />
    </div>
</template>
